var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 109,
    viewBox: "0 0 110 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1853 18.3576C19.9617 26.7255 10.2731 49.8255 18.5431 69.9545C26.8154 90.0836 49.9156 99.6184 70.1396 91.251C90.3633 82.8846 100.052 59.7842 91.7805 39.6557C83.509 19.5269 60.4085 9.99151 40.1853 18.3576Z",
    fill: "#4B5E7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7481 27.0303C28.3375 33.4053 20.9539 51.0095 27.2573 66.3498C33.5602 81.6881 51.1644 88.9553 66.5751 82.5794C81.9872 76.202 89.3712 58.5983 83.0674 43.2597C76.7641 27.9209 59.1603 20.6543 43.7481 27.0303Z",
    fill: "#4B5E7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6279 26.6742C44.6913 26.845 45.9679 26.4557 48.2932 26.0168C50.6108 25.593 54.0357 25.1595 58.1822 25.674C60.2484 25.9328 62.483 26.4243 64.776 27.2483C67.0589 28.0911 69.4094 29.2384 71.6402 30.8043C72.7576 31.5816 73.8576 32.4459 74.89 33.424C75.9282 34.3965 76.9342 35.449 77.8422 36.6153C78.7522 37.7759 79.6165 39.0103 80.3604 40.3424C81.106 41.6721 81.7662 43.0742 82.3262 44.5387C82.8657 46.0109 83.2903 47.5031 83.6017 48.9962C83.9159 50.4915 84.0765 51.9913 84.1534 53.4678C84.2355 54.9465 84.1692 56.4041 84.0269 57.8218C83.892 59.2418 83.6305 60.6196 83.3007 61.9438C82.6489 64.5975 81.6338 67.0175 80.4689 69.1606C79.2849 71.2971 77.9264 73.1458 76.5415 74.7084C73.7601 77.8368 70.8996 79.7767 68.8783 80.9916C66.8404 82.1989 65.6243 82.7503 65.6906 82.9209C65.7349 83.0481 67.0626 82.7819 69.293 81.7854C71.5026 80.7816 74.6376 78.9746 77.7338 75.8167C79.2739 74.2395 80.7952 72.3378 82.1307 70.1025C83.4472 67.8619 84.602 65.3026 85.3606 62.4682C85.7444 61.0548 86.0513 59.5794 86.2203 58.0533C86.3968 56.5295 86.4863 54.9589 86.4155 53.3636C86.3492 51.7695 86.1862 50.1492 85.8562 48.5339C85.5295 46.9189 85.0742 45.3073 84.4912 43.7209C83.8883 42.1418 83.1732 40.6294 82.3604 39.199C81.5491 37.7661 80.6072 36.4393 79.6122 35.1967C78.6197 33.9496 77.5216 32.8275 76.3883 31.7994C75.2602 30.7636 74.0615 29.8556 72.8458 29.0456C70.4162 27.417 67.869 26.2555 65.4072 25.4398C62.9383 24.6441 60.5438 24.2182 58.3513 24.0508C53.9492 23.7233 50.4056 24.4387 48.0845 25.1444C45.752 25.8705 44.579 26.5482 44.6279 26.6742Z",
    fill: "#4B5E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg6);
export default __webpack_public_path__ + "static/media/bg-6.fa934d09b9f164d2922bbe6f8629d5c3.svg";
export { ForwardRef as ReactComponent };